import React from 'react';
import logo from '../TBL Logo White.png';
import './WinemakersMenu.css';

const WinemakersMenu = ({ onSelectWinery, onBack }) => {
  const wineries = [
    {
      id: 'blending-lab',
      name: 'The Blending Lab',
      logo: '/The Blending Lab/TBL Logo Black.png'
    },
    {
      id: 'alta-colina',
      name: 'Alta Colina',
      logo: '/Alta Collina/AC_logoText.jpeg'
    },
    {
      id: 'castoro',
      name: 'Castoro',
      logo: '/Castoro/CC_LogoFull_CMYK-01.png'
    },
    {
      id: 'grey-wolf',
      name: 'Grey Wolf',
      logo: '/Grey Wolf/GREY_LOGO-signature-black.jpg'
    }
  ];

  return (
    <div className="winemakers-menu">
      <div className="back-button-container">
        <button 
          className="winemakers-back-btn" 
          onClick={onBack}
        >
          ← Back to Menu
        </button>
      </div>
      <header className="winemakers-header">
        <img src="/Blendfest Logo.png" className="winemakers-logo" alt="logo" />
        <h1>Meet the Winemakers</h1>
        <p className="winemakers-description">
          Select a winery to learn more
        </p>
      </header>

      <div className="winemakers-grid">
        {wineries.map((winery) => (
          <div 
            key={winery.id} 
            className="winery-tile" 
            onClick={() => onSelectWinery(winery.id)}
          >
            <img 
              src={winery.logo} 
              alt={winery.name} 
              className="winery-logo"
            />
          </div>
        ))}
      </div>

      <div className="footer">
        <div className="footer-separator"></div>
        <img src={logo} className="footer-logo" alt="TBL Logo" />
      </div>
    </div>
  );
};

export default WinemakersMenu;
